import React, { Component } from 'react';
import { Popup } from '@lyearn-team/frontend-components';
import Radium, { Style } from 'radium';
import OverlayLoader from '../OverlayLoader';
import ErrorPopup from '../../helper/ErrorPopup';

@Radium
class ElementsHandler extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showLoading: false,
      showIdleDialog: false
    };

    ErrorPopup.init();
    this.submissionOnFlag = false;
  }

  showLoading = () => {
    this.setState({
      showLoading: true
    });
  };

  hideLoading = () => {
    this.setState({
      showLoading: false
    });
  };

  submissionOn = flag => {
    this.submissionOnFlag = flag;
  };

  showIdleDialog = () => {
    if (this.submissionOnFlag) {
      this.setState({ showIdleDialog: true });
      return;
    }
    window.location.reload(true);
  };

  handleCloseIdleDialog = () => {
    this.setState({ showIdleDialog: false });
  };

  refreshPage = () => {
    window.location.reload();
  };

  render() {
    return (
      <div>
        {this.state.showIdleDialog && (
          <div style={{ zIndex: '1001', position: 'fixed' }}>
            <Popup
              header=""
              onCloseClick={this.handleCloseIdleDialog}
              footer={[
                {
                  key: 'Ok',
                  text: 'Ok',
                  type: 'filled',
                  size: 'medium',
                  onClick: this.refreshPage
                },
                {
                  key: 'Cancel',
                  text: 'Cancel',
                  size: 'medium',
                  onClick: this.handleCloseIdleDialog
                }
              ]}
              showPopup={this.state.showIdleDialog}
            >
              {this.submissionOnFlag
                ? 'No activity detected for 30 minutes, press OK to refresh, or press Cancel and save your work and refresh immediately. '
                : 'No activity detected for 30 minutes, press OK to refresh'}
            </Popup>
          </div>
        )}
        {this.state.showLoading ? <OverlayLoader /> : null}
        <Style />
      </div>
    );
  }
}

export default ElementsHandler;
